import React, { useCallback } from "react";
import { ReactSVG } from "react-svg";
import { useNavigate } from "react-router-dom";

// Libraries
import { ArrowForwardIos } from "@libraries/icons";

import * as Styled from "./styles";

interface DashboardWebLinkProps {
  icon: string;
  title: string;
  link: string;
}

const DashboardWebLink: React.FC<DashboardWebLinkProps> = ({
  icon,
  title,
  link
}) => {
  const navigate = useNavigate();

  const handleNavigate = useCallback(() => {
    navigate(link);
  }, [link, navigate]);

  return (
    <Styled.Container>
      <Styled.Content>
        <ReactSVG src={icon} alt={title} />
        <Styled.Title>{title}</Styled.Title>
      </Styled.Content>

      <Styled.Action onClick={handleNavigate}>
        <ArrowForwardIos />
      </Styled.Action>
    </Styled.Container>
  );
};

export default DashboardWebLink;
